import { render } from "./action.vue?vue&type=template&id=731f3bb5"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__